import { computed } from 'vue';

import { useCampv2InputStore } from '@/features/Sparten/campv2/useInputStore';
import { WKZ } from '@/features/Sparten/shared/types/kfz/types';

/**
 * Ist das Fahrzeug ein Wohnmobil (WKZ 127)? Steuert u.a. den Hersteller-Pflichtstatus.
 * Der `allgemein`-Guard verhindert Fehler, solange der Store noch nicht befüllt ist.
 */
export const isWkz127 = computed(
  (): boolean =>
    useCampv2InputStore().allgemein !== undefined &&
    useCampv2InputStore().allgemein.wkz === WKZ.CAMPING_WOHNMOBIL,
);
